diy.angular.registerFactory('diyfmallimagesmodel', [
    'diyfmconststorage', 
    'diyfmfoldermodel' /* it's required even if not directly used */,
function(diyfmconststorage, diyfmfoldermodel) {

    // constructor
    var diyfmallimagesmodel = function (title) {
        diyfmfoldermodel.apply(this, [{
            type: diyfmconststorage
        }, title, {}]); //call parent constructor
    };
    
    // diyfmallimagesmodel extends diyfmfoldermodel
    diyfmallimagesmodel.prototype = Object.create(diyfmfoldermodel.prototype);
    
    // public methods
    angular.extend(diyfmallimagesmodel.prototype, {
        isNew: function() {
            return false;
        },
        setTitle: function(newTitle) {
            throw new Error("Can't change title for AllImagesSubsection");
        },

        getActions: function() {
            return this._emptyActions;
        },

        canMoveTo: function() { 
            return false; 
        },
        
        _removeItemsOnMove: function(moveItems) {
            // to nothing as after move items should be still in "all images"
        },
        
        _afterItemsMoved: function(moveItems) {
            // do nothing here because on move it is still in all images collection
            // but we still need to clear caches on real source folders
        },
        
        getDefaultParams: function()
        {
            return {}; // no folderId filter provided
        },
        /* Implementing Observer pattern
         * a folder can observe
         */
        update: function(subject, event, data) {
            if (subject instanceof diyfmfoldermodel) {
                switch(event) {
                    case 'deleted':
                    case 'itemsDeleted':
                    case 'itemsCreated':
                    case 'itemsUpdated':
                        // TODO make a smarter handler that actually updates it's local cache
                        // based on provided data
                        this.clearItemsCache();
                        break;
                }
            }
        }
                
    });
    return diyfmallimagesmodel;
}]);


/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/filemanager/models/diyfmallimagesmodel.js
 ** module id = 957
 ** module chunks = 0
 **/